import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

gsap.registerPlugin(ScrollTrigger);

document.addEventListener("DOMContentLoaded", () => {
  const blogHeading = document.querySelector(".blog-heading");
  const fades = document.querySelectorAll(".fade");

  gsap.fromTo(
    blogHeading,
    {
      opacity: 0,
      y: 50,
      filter: "blur(5px)",
    },
    {
      opacity: 1,
      y: 0,
      filter: "blur(0px)",
      duration: 1.2,
      ease: "power3.out",
      scrollTrigger: {
        trigger: blogHeading,
        start: "top 80%", // starts when the heading is near the viewport
        toggleActions: "play none none reverse", // animates back when scrolling up
      },
    }
  );

  fades.forEach((fade) => {
    gsap.fromTo(
      fade,
      {
        opacity: 0,
        filter: "blur(10px)",
        y: 30,
      },
      {
        opacity: 1,
        filter: "blur(0px)",
        y: 0,
        duration: 1.3,
        ease: "power3.out",
        scrollTrigger: {
          trigger: fade,
          start: "top 85%", // play when each element enters viewport
          toggleActions: "play none none reverse", // plays forward + reverses when leaving
        },
      }
    );
  });
});
